/* KAECE select · 29.10.26
   Replaces the browser's own dropdown list with KAECE's, everywhere a <select> is shown.
   The native select stays in the page (hidden) so forms, change events and the theme keep working;
   only what the customer sees and touches is ours. Short lists open as a list under the field
   (above it when there is no room, as in the phone bar). Long lists (country and currency) open as a
   side drawer with a search field, in line with every other overlay on the site.
   Auto: select.kf__select, select[data-kf-country], select[data-ks], the phone bar's size select (added to the body later,
   picked up by the observer below). Manual: KAECE.select(el). */
(function () {
  'use strict';
  var LONG = 16;
  var uid = 0;
  var openOne = null;

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function txt(o) { return o ? o.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function enhance(sel) {
    if (!sel || sel._ks || sel.multiple) return sel && sel._ks;
    var id = 'ks' + (++uid);
    var long = sel.options.length > LONG || sel.hasAttribute('data-kf-country');
    var wrap = el('div', 'ks' + (long ? ' ks--long' : ''));
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add('ks__native');
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');

    var btn = el('button', 'ks__btn ' + sel.className.replace(/\bks__native\b/, '').trim());
    btn.type = 'button';
    btn.id = id + '-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var label = sel.id ? document.querySelector('label[for="' + sel.id + '"]') : null;
    var name = label ? txt(label) : (sel.getAttribute('aria-label') || '');
    if (label) { label.htmlFor = btn.id; if (!label.id) label.id = id + '-lab'; }
    var val = el('span', 'ks__val');
    btn.appendChild(val);
    btn.appendChild(el('span', 'ks__chev'));
    wrap.insertBefore(btn, sel);

    var panel = el('div', 'ks__panel');
    panel.id = id + '-list';
    panel.hidden = true;
    var head, search, list = el('ul', 'ks__list');
    list.setAttribute('role', 'listbox');
    list.id = id + '-lb';
    list.tabIndex = -1;
    if (name) list.setAttribute('aria-label', name);
    btn.setAttribute('aria-controls', list.id);
    var wash = null;
    if (long) {
      head = el('div', 'ks__head');
      head.appendChild(el('span', 'ks__title', name || 'Choose'));
      var close = el('button', 'ks__close', 'Close'); close.type = 'button';
      close.addEventListener('click', function () { hide(true); });
      head.appendChild(close);
      search = el('input', 'ks__search');
      search.type = 'text';
      search.setAttribute('autocomplete', 'off');
      search.setAttribute('placeholder', 'Search');
      search.setAttribute('aria-label', 'Search ' + (name || 'options'));
      search.setAttribute('aria-controls', list.id);
      panel.appendChild(head);
      panel.appendChild(search);
      panel.classList.add('ks__panel--drawer');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      if (name) panel.setAttribute('aria-label', name);
      wash = el('div', 'ks__wash');
      wash.addEventListener('click', function () { hide(true); });
      document.body.appendChild(wash);
      document.body.appendChild(panel);
    } else {
      wrap.appendChild(panel);
    }
    panel.appendChild(list);

    var active = -1, items = [], typed = '', typedAt = 0;

    function sync() {
      var o = sel.options[sel.selectedIndex];
      val.textContent = o ? txt(o) : '';
      wrap.classList.toggle('is-empty', !sel.value);
      btn.disabled = sel.disabled;
    }
    function build(filter) {
      list.innerHTML = '';
      items = [];
      var q = (filter || '').toLowerCase();
      [].forEach.call(sel.options, function (o, i) {
        if (q && txt(o).toLowerCase().indexOf(q) < 0) return;
        var li = el('li', 'ks__opt', txt(o));
        li.id = id + '-o' + i;
        li.setAttribute('role', 'option');
        li.setAttribute('data-i', i);
        li.setAttribute('aria-selected', i === sel.selectedIndex ? 'true' : 'false');
        if (o.disabled) { li.setAttribute('aria-disabled', 'true'); li.classList.add('is-off'); }
        if (o.value === '' && !long) li.classList.add('is-ph');
        list.appendChild(li);
        items.push(li);
      });
      if (!items.length) list.appendChild(el('li', 'ks__none', 'No match'));
    }
    function mark(k, scroll) {
      items.forEach(function (it, j) { it.classList.toggle('is-active', j === k); });
      active = k;
      var it = items[k];
      if (it) {
        (long ? search : list).setAttribute('aria-activedescendant', it.id);
        if (scroll) {
          var top = it.offsetTop, bot = top + it.offsetHeight;
          if (top < list.scrollTop) list.scrollTop = top;
          else if (bot > list.scrollTop + list.clientHeight) list.scrollTop = bot - list.clientHeight;
        }
      }
    }
    function move(d) {
      if (!items.length) return;
      var k = active;
      for (var n = 0; n < items.length; n++) {
        k = (k + d + items.length) % items.length;
        if (!items[k].classList.contains('is-off')) break;
      }
      mark(k, true);
    }
    function choose(li) {
      if (!li || li.classList.contains('is-off')) return;
      var i = +li.getAttribute('data-i');
      var changed = i !== sel.selectedIndex;
      sel.selectedIndex = i;
      sync();
      hide(true);
      if (changed) {
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    function place() {
      if (long) return;
      wrap.classList.remove('ks--up');
      var r = btn.getBoundingClientRect();
      var h = Math.min(panel.scrollHeight || 280, 280);
      var below = window.innerHeight - r.bottom, above = r.top;
      if (sel.hasAttribute('data-ks-up') || (below < h + 8 && above > below)) wrap.classList.add('ks--up');
    }
    function show() {
      if (btn.disabled) return;
      if (openOne && openOne !== api) openOne.hide(false);
      openOne = api;
      build('');
      panel.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      if (long) {
        wash.classList.add('is-open');
        document.documentElement.classList.add('ks-lock');
        requestAnimationFrame(function () { panel.classList.add('is-in'); wash.classList.add('is-in'); });
        search.value = '';
        setTimeout(function () { search.focus({ preventScroll: true }); }, 30);
      } else {
        place();
        list.focus({ preventScroll: true });
      }
      var cur = Math.max(0, items.findIndex ? items.findIndex(function (it) { return +it.getAttribute('data-i') === sel.selectedIndex; }) : 0);
      mark(cur, true);
    }
    function hide(focus) {
      if (panel.hidden || !wrap.classList.contains('is-open')) return;
      if (long) { panel.classList.remove('is-in'); setTimeout(function () { if (!wrap.classList.contains('is-open')) panel.hidden = true; }, 450); }
      else panel.hidden = true;
      wrap.classList.remove('is-open', 'ks--up');
      btn.setAttribute('aria-expanded', 'false');
      if (wash) { wash.classList.remove('is-open', 'is-in'); document.documentElement.classList.remove('ks-lock'); }
      if (openOne === api) openOne = null;
      if (focus) btn.focus({ preventScroll: true });
    }

    btn.addEventListener('click', function () { wrap.classList.contains('is-open') ? hide(true) : show(); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); show(); }
    });
    list.addEventListener('click', function (e) { choose(e.target.closest('.ks__opt')); });
    list.addEventListener('mousemove', function (e) {
      var li = e.target.closest('.ks__opt');
      if (li && items.indexOf(li) !== active) mark(items.indexOf(li), false);
    });
    function keys(e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Home') { e.preventDefault(); mark(0, true); }
      else if (e.key === 'End') { e.preventDefault(); mark(items.length - 1, true); }
      else if (e.key === 'Enter' || (e.key === ' ' && !long)) { e.preventDefault(); choose(items[active]); }
      else if (e.key === 'Escape') { e.preventDefault(); hide(true); }
      else if (e.key === 'Tab') { if (long) { e.preventDefault(); (document.activeElement === search ? close : search).focus(); } else hide(false); }
      else if (!long && e.key.length === 1 && /\S/.test(e.key)) {
        var now = Date.now();
        typed = (now - typedAt < 700 ? typed : '') + e.key.toLowerCase();
        typedAt = now;
        for (var k = 0; k < items.length; k++) if (items[k].textContent.toLowerCase().indexOf(typed) === 0) { mark(k, true); break; }
      }
    }
    list.addEventListener('keydown', keys);
    if (long) {
      search.addEventListener('keydown', keys);
      close.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); hide(true); }
        else if (e.key === 'Tab') { e.preventDefault(); search.focus(); }
      });
      search.addEventListener('input', function () { build(search.value.trim()); mark(0, false); list.scrollTop = 0; });
    }
    document.addEventListener('click', function (e) {
      if (long || !wrap.classList.contains('is-open')) return;
      if (!wrap.contains(e.target)) hide(false);
    });
    sel.addEventListener('change', sync);
    if (window.MutationObserver) new MutationObserver(sync).observe(sel, { childList: true, subtree: true, characterData: true, attributes: true });

    var api = { sync: sync, show: show, hide: hide, button: btn };
    sel._ks = api;
    sync();
    return api;
  }

  function scan(root) {
    [].forEach.call((root || document).querySelectorAll('select.kf__select, select[data-kf-country], select[data-ks], .kp-bar__sz select'), enhance);
  }

  window.KAECE = window.KAECE || {};
  window.KAECE.select = enhance;
  window.KAECE.selectScan = scan;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  /* blocks added to the page later (the phone bar on the product page) */
  if (window.MutationObserver) {
    var watch = function () { new MutationObserver(function (ms) { ms.forEach(function (m) { [].forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1 && n.querySelector && n.querySelector('select')) scan(n); }); }); }).observe(document.body, { childList: true }); };
    if (document.body) watch(); else document.addEventListener('DOMContentLoaded', watch);
  }
  document.addEventListener('DOMContentLoaded', function () { document.dispatchEvent(new CustomEvent('kaece:select-ready')); });
})();
